import { useEffect, useState } from 'react';
import { Row, InputGroup, Col } from 'react-bootstrap';
import { SearchSVG } from '../../../../../Member/img/GlobalSVG';
import TextInput from '../../../common/text-input';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import { CLIENT_TYPES, MONTHS } from 'src/constants';
import { useDispatch, useSelector } from 'react-redux';
import PrimaryButton from '../../../common/button';
import { DATE_SELECTIONS_OPTIONS } from '../../../../../constants/index';
import 'react-datepicker/dist/react-datepicker.css';
//import DatePicker from 'react-datepicker';
import DatePicker from '../../../common/DatePicker';
import {
  resetPageSizeandNumber,
  resetSearchParams,
  setSearchParams,
} from 'src/redux/admin/claimsSlice';
import { getMonth, getYear } from 'date-fns';
import moment from 'moment';
import range from 'lodash/range';
const ClaimListFilter = ({ uniqueNames, uniqueTypes }) => {
  const dispatch = useDispatch();
  const {
    searchParms: {
      claimNumber,
      claimType,
      claimCategory,
      claimDuration,
      startDate: strtDate,
      endDate: enDate,
    },
  } = useSelector(({ claims }) => claims);
  const frameOptions = (optionsData) => {
    const options = [];
    if (optionsData?.length) {
      optionsData.forEach((element) => {
        options.push({ label: element, value: element });
      });
    }
    return options;
  };

  const isMobileClient = useSelector(({ app }) => {
    return app.clientType === CLIENT_TYPES.MOBILE;
  });

  const claimSearchHandler = (event) => {
    const searchTerm = event.target.value.replace(/  +/g, ' ');
    dispatch(setSearchParams({ claimNumber: searchTerm }));
    dispatch(resetPageSizeandNumber());
  };

  const resetFilterHandler = (event) => {
    event.preventDefault();
    setShowCustomDatePicker(false);
    setStartDate(new Date().setFullYear(new Date().getFullYear() - 1));
    setEndDate(new Date());
    setMaxDate(new Date());
    const claimCategoryData = claimCategory;
    dispatch(resetSearchParams());
    dispatch(setSearchParams({ claimCategory: claimCategoryData }));
  };

  const [showMobileFilter, setShowMobileFilter] = useState(false);

  //Initiation of Apply Filter all other filters are set at the time of selection in the mobile filter
  //Inorder to initate search just using Claimnumber we can use any other filter option also search will happen for all filters

  const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(
    claimDuration.label === 'Date Range' && strtDate !== ''
      ? strtDate
      : new Date().setFullYear(new Date().getFullYear() - 1),
  );
  const [endDate, setEndDate] = useState(
    claimDuration.label === 'Date Range' && enDate !== '' ? enDate : new Date(),
  );

  const [maxDate, setMaxDate] = useState(
    claimDuration.label === 'Date Range' && strtDate !== ''
      ? new Date(strtDate).setFullYear(new Date(strtDate).getFullYear() + 1)
      : new Date(),
  );
  const handleStartDate = (date) => {
    if (new Date().getFullYear() === new Date(date).getFullYear()) {
      setMaxDate(new Date());
    } else {
      if (
        new Date() <
        new Date(date).setFullYear(new Date(date).getFullYear() + 1)
      ) {
        setMaxDate(new Date());
      } else {
        //setMaxDate(
        //new Date( date ).setFullYear( new Date( date ).getFullYear() + 1 ),
        //);
      }
    }
    setStartDate(date);
    dispatch(setSearchParams({ startDate: date }));
    setEndDate(null);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
    dispatch(setSearchParams({ endDate: date }));
  };

  useEffect(() => {
    if (claimDuration.label === 'Date Range') {
      setShowCustomDatePicker(true);
    } else {
      setShowCustomDatePicker(false);
    }
  }, [claimDuration]);
  //Claim Range Configuration
  const {
    appConfigs: { Common_Setting },
  } = useSelector(({ app }) => app);
  const claimsYearRange =
    Common_Setting?.Claims_Year_Range !== undefined
      ? Common_Setting?.Claims_Year_Range
      : 5;

  const years = range(
    getYear(new Date()) - claimsYearRange,
    getYear(new Date()) + 1,
    1,
  );
  const months = [...MONTHS];

  const handleDateChange = (dates) => {
    if (moment(dates[0]).isValid()) {
      setStartDate(dates[0]);
    }
    if (moment(dates[1]).isValid() && moment(dates[0]) < moment(dates[1])) {
      setEndDate(dates[1]);
      dispatch(
        setSearchParams({
          startDate: dates[0],
          endDate: dates[1],
        }),
      );
    }
  };

  return (
    <>
      <Row className="claims-filter-bar align-items-center admin-center-claim-filter-bar">
        <Col xs={8} sm={6} md={3} className="border-right-claims">
          <div className="claims-filter-control">
            <TextInput
              parentClassName="claim-search"
              append={
                <InputGroup.Text>
                  <SearchSVG.SearchSVG className="primary-text-color" />
                </InputGroup.Text>
              }
              inputProps={{
                type: 'text',
                placeholder: 'By Claim or Provider',
                className: 'border-right-0 height-32',
                autoFocus: true,
                value: claimNumber,
                onChange: claimSearchHandler,
              }}
            />
          </div>
        </Col>
        {!isMobileClient ? (
          <>
            <div className="col-xs-12 col-sm-7 col-md-7">
              <div className="claims-filter-control">
                <Row>
                  <Col>
                    <AutoSuggestionSelectComponent
                      placeholder="Claim Type"
                      options={frameOptions(uniqueTypes)}
                      isMulti
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="height-32"
                      value={frameOptions(claimType)}
                      onChange={(event) => {
                        const options = [];
                        if (event?.length > 0) {
                          event.forEach((element) => {
                            options.push(element.value);
                          });
                        }
                        dispatch(setSearchParams({ claimType: options }));
                        dispatch(resetPageSizeandNumber());
                      }}
                    />
                  </Col>
                  <Col>
                    <AutoSuggestionSelectComponent
                      placeholder="Service Date"
                      options={
                        uniqueNames?.length > 0 ? DATE_SELECTIONS_OPTIONS : []
                      }
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="height-32"
                      value={claimDuration}
                      onChange={(event) => {
                        if (event.label === 'Date Range') {
                          setShowCustomDatePicker(true);
                          dispatch(
                            setSearchParams({
                              startDate: new Date().setFullYear(
                                new Date().getFullYear() - 1,
                              ),
                            }),
                          );
                          dispatch(setSearchParams({ endDate: new Date() }));
                          setStartDate(
                            new Date().setFullYear(
                              new Date().getFullYear() - 1,
                            ),
                          );
                          setEndDate(new Date());
                          setMaxDate(new Date());
                        } else {
                          setShowCustomDatePicker(false);
                          dispatch(setSearchParams({ startDate: '' }));
                          dispatch(setSearchParams({ endDate: '' }));
                        }
                        dispatch(setSearchParams({ claimDuration: event }));
                        dispatch(resetPageSizeandNumber());
                      }}
                    />
                  </Col>
                  {/*<Col>
                    {showCustomDatePicker && (
                      <div className="height-32 claims-date-picker-admin claim-start-date">
                        <DatePicker
                          renderCustomHeader={({
                            date,
                            changeYear,
                            changeMonth,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div
                              style={{
                                margin: 10,
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <button
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                              >
                                {'<'}
                              </button>
                              <select
                                className="custom-scroller"
                                value={getYear(date)}
                                onChange={({ target: { value } }) =>
                                  changeYear(value)
                                }
                              >
                                {years.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>

                              <select
                                value={months[getMonth(date)]}
                                onChange={({ target: { value } }) =>
                                  changeMonth(months.indexOf(value))
                                }
                              >
                                {months.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>

                              <button
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                              >
                                {'>'}
                              </button>
                            </div>
                          )}
                          selected={startDate}
                          maxDate={new Date()}
                          placeholderText="From Date"
                          onChange={handleStartDate}
                        />
                      </div>
                    )}
                  </Col> */}
                  <Col xs={5}>
                    {showCustomDatePicker && (
                      <div className="height-32 claims-date-picker-admin claim-end-date">
                        {/*<DatePicker
                          renderCustomHeader={({
                            date,
                            changeYear,
                            changeMonth,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div
                              style={{
                                margin: 10,
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <button
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                              >
                                {'<'}
                              </button>
                              <select
                                className="custom-scroller"
                                value={getYear(date)}
                                onChange={({ target: { value } }) =>
                                  changeYear(value)
                                }
                              >
                                {years.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>

                              <select
                                value={months[getMonth(date)]}
                                onChange={({ target: { value } }) =>
                                  changeMonth(months.indexOf(value))
                                }
                              >
                                {months.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>

                              <button
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                              >
                                {'>'}
                              </button>
                            </div>
                          )}
                          selected={endDate}
                          minDate={startDate}
                          maxDate={maxDate}
                          placeholderText="To Date"
                          onChange={handleEndDate}
                        /> */}
                        <DatePicker
                          allowFutureDates={true}
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={handleDateChange}
                          onChangeRaw={(e) => {
                            if (e.target.value) {
                              const dates = e.target.value
                                .split(' - ')
                                .map((date) => {
                                  const d = new Date(date);
                                  return d;
                                });
                              handleDateChange(dates);
                            }
                          }}
                          showIcon={true}
                          placeholder={'MM-DD-YYYY - MM-DD-YYYY'}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
            <Col xs={2}>
              <a className="claims-reset-filter" onClick={resetFilterHandler}>
                Reset Filters
              </a>
            </Col>
          </>
        ) : (
          <Col xs="4">
            <PrimaryButton
              className="show-all-filters-button height-32"
              onClick={() => setShowMobileFilter(!showMobileFilter)}
            >
              FILTER
            </PrimaryButton>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ClaimListFilter;
